import React from 'react';
import { Card, Grid, Transition } from 'semantic-ui-react';

import Base from './Base';
import { PersonInfo } from 'src/components/coreUI';

type Props = {
  user?: {
    avatarUrl?: string;
    name?: string;
    date?: string;
  };
};

export default class LibraryCourse extends Base<Props> {
  render() {
    const { onClick, extra, user = {} } = this.props;

    return (
      <Transition animation="fade down" transitionOnMount duration={500}>
        <Card fluid onClick={onClick}>
          {this.renderBase()}
          <Card.Content extra>
            <Grid doubling columns={2}>
              <Grid.Column>
                <PersonInfo
                  avatarUrl={user.avatarUrl}
                  name={user.name}
                  date={user.date}
                />
              </Grid.Column>
              <Grid.Column>{extra}</Grid.Column>
            </Grid>
          </Card.Content>
        </Card>
      </Transition>
    );
  }
}
